import React from "react";
import { s3baseUri } from "../../../../config/config";

export default function BlogCard({ item, index, handleDeatilAffilations }) {
  return (
    <div
      key={index}
      // className="col-md-3 col-sm-6 col-12"
      className="col-12 col-sm-6 col-md-3 custom-col-5 mt-3 d-flex "
    >
      <div
        className="card-1 d-flex flex-column h-100 shadow-sm cursor-pointer"
        onClick={() => handleDeatilAffilations(item)}
      >
        <img
          style={{ cursor: "pointer" }}
          onClick={() => handleDeatilAffilations(item)}
          src={s3baseUri + item.image[0]?.thumbnail_2}
          alt={item?.title}
          className="card-img-top p-0"
        />

        <div className="card-body flex-grow-1 d-flex flex-column card-content-partners">
          <h5 className="card-title line-clamp-2">{item.title}</h5>
          <p className="card-text">
            <div
              className="line-clamp-3"
              dangerouslySetInnerHTML={{
                __html: item?.short_description,
              }}
            ></div>
          </p>
        </div>
      </div>
    </div>
  );
}
